import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, IconButton, List, ListItem, ListItemText, makeStyles } from '@material-ui/core';
import { Close, Public } from '@material-ui/icons';
import React from 'react';

const useStyles = makeStyles((theme)=>({
    Title : {
        fontFamily: 'primary !important',
        fontWeight: '800 !important',
        fontSize: '1.2rem !important',
        lineHeight: '24px',
        letterSpacing: '-0.011em',
    },
    Content : {
        fontFamily: 'Inter',
        fontStyle: 'normal',
        fontWeight: '500',
        fontSize: '16px',
        lineHeight: '24px',
        letterSpacing: '-0.011em',
    },
    ScrollableContent : {
        fontFamily: 'Inter',
        fontStyle: 'normal',
        fontWeight: '500',
        fontSize: '16px',
        lineHeight: '24px',
        letterSpacing: '-0.011em',
        overflowY: 'auto',
        maxHeight: '30vh',
    },
    root : { 
        justifyContent : 'flex-start',
        padding : '0',
        overflowX: 'hidden',
        whiteSpace: 'nowrap',
        fontSize : '16px !important',
        fontWeight : '400 !important',
    },
    rootMob : { 
        justifyContent : 'flex-start',
        padding : '0',
        overflowX: 'hidden',
        whiteSpace: 'nowrap',
        fontSize : '10px !important',
        fontWeight : '400 !important',
    },
    PaperMob : {
        width : '100%',
        backgroundColor : 'black',
        color : 'white',
    },
    Paper : {
        width : '50%',
        backgroundColor : 'black',
        color : 'white',
    },
    Close: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color : '#fe752f',
        "& .MuiSvgIcon-root" : {
            fontSize : '1.5rem !important',
            color : '#fe752f',
        },
        '&:hover' : {
            backgroundColor : 'transparent',
            color : '#fe752f',
            border : 'none',
        }
    },
    CloseMob: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color : '#fe752f',
        "& .MuiSvgIcon-root" : {
            fontSize : '1rem !important',
            color : '#fe752f',
        },
        '&:hover' : {
            backgroundColor : 'transparent',
            color : '#fe752f',
            border : 'none',
        }
    },
    listItem : {
        marginBottom : '1vh',
        borderRadius : '5px',
        backgroundColor : 'black',
        color : 'white',
    },
    button : {
        color : '#fe752f',
        "& .MuiSvgIcon-root" : {
            fontSize : '1.5rem !important',
            color : '#fe752f',
        },
        "& :hover" : {
            backgroundColor : 'transparent',
            color : '#fe752f',
            border : 'none',
        },
    },
    buttonMob : {
        color : '#fe752f',
        "& .MuiSvgIcon-root" : {
            fontSize : '1.5rem !important',
            color : '#fe752f',
        },
        "& :hover" : {
            backgroundColor : 'transparent',
            color : '#fe752f',
            border : 'none',
        },
    }
}))

const InfoPrompt = function InfoPrompt({ info, open, handleClose, view }){

    const classes = useStyles();

    const PubPvtInfo = () => {
        return (
            <List>
                <ListItem classes={{ root : classes.listItem }} >
                    <ListItemText primary="Public mode renders your room visible to all users in local network." /> 
                </ListItem>
                <ListItem classes={{ root : classes.listItem }} >
                    <ListItemText primary="Private mode renders your room invisible to all users in local network." /> 
                </ListItem>
                <ListItem classes={{ root : classes.listItem }} >
                    <ListItemText primary="Private mode also enables receivers to ask permission before entering the room." /> 
                </ListItem>
                <ListItem classes={{ root : classes.listItem }} >
                    <ListItemText secondary="Click to see feature in our 'How it works' video." /> 
                </ListItem>
            </List>
        )
    }

    const AudioInfo = () => {
        return(
            <List>
                <ListItem classes={{ root : classes.listItem }} >
                    <ListItemText primary="Send your room code to nearby users" /> 
                </ListItem>
                <ListItem classes={{ root : classes.listItem }} >
                    <ListItemText primary="Users can listen to the room code by clicking the mic button in the home page." /> 
                </ListItem>
                <ListItem classes={{ root : classes.listItem }} >
                    <ListItemText primary="The audio button sends sound waves only for a short duration." /> 
                </ListItem>
                <ListItem classes={{ root : classes.listItem }} >
                    <ListItemText secondary="Click to see feature in our 'How it works' video." /> 
                </ListItem>
            </List>
        )
    }

    return(
        <Dialog fullWidth={ view === 'mobile' ? true : false } classes={{ paper : view === 'mobile' ? classes.PaperMob : classes.Paper }} maxWidth='xl' open={open} >
            <DialogTitle disableTypography={true} classes={{ root : classes.Title }} >
                { info === 'room' ? "Switch between public and private rooms" : "Share the room code via sound waves" }
                <IconButton classes={{ root : view === 'mobile' ? classes.CloseMob : classes.Close }} onClick={handleClose} >
                    <Close />
                </IconButton>
            </DialogTitle>
            <DialogContent classes={{ root : classes.ScrollableContent }}>
                <Divider />
                { info === 'room' ? PubPvtInfo() : AudioInfo() }
            </DialogContent>
            <DialogActions>
                <Button classes={{ root : classes.button }} endIcon={
                    <IconButton classes={{ root : view === 'mobile' ? classes.buttonMob : classes.button}} >
                        <Public />
                    </IconButton>
                } >
                    VISIT
                </Button>
            </DialogActions>
        </Dialog>
    )

}

export default InfoPrompt;